import React from 'react';
import { StatusChip, Tooltip } from '@/components/ui';

interface ImportProgressStatusProps {
  status: string;
  description: string;
}

export const ImportProgressStatus: React.FC<ImportProgressStatusProps> = ({
  status,
  description,
}) => {
  // Map status to import_mapping entity type
  // Some statuses might need special handling
  let mappedStatus = status;
  
  // Handle uploaded status - map to imported for import_mapping entity
  if (status === 'uploaded') {
    mappedStatus = 'imported';
  }

  return (
    <Tooltip content={description}>
      <StatusChip
        entityType="import_mapping"
        status={mappedStatus}
      />
    </Tooltip>
  );
};
